export const verificacaoPorAtendimento = ({
  tipoRepasse,
  tipoCalculoRepasse,
  valorSemMask,
  percentualRepasseSemMask,
}) =>
  tipoRepasse.value === "POR_ATENDIMENTO" &&
  ((tipoCalculoRepasse?.value === "PERCENTIL" && !percentualRepasseSemMask) ||
    (tipoCalculoRepasse?.value === "VALOR" && !valorSemMask));
